export enum CacheStatus {
  preparing = <any>'preparing',
  complete = <any>'complete'
}
